import React, { useContext, useEffect, useState } from "react";
import India from "../../flags/IN.svg";
import SearchIcon from "../../assets/testRide/searchIcon.svg";
import AlertInfoIcon from "../../assets/testRide/alert-info.png";
import Text from "../../atoms/text/text";
import LoaderLight from "../../atoms/loaderLight/loaderLight";
import { LoginContext } from "../../context/LoginContext";
import loaderData from "../../assets/loader.json";

import { useHistory } from "react-router-dom";

import "./CustomerSearch.scss";

import { makeAPICall } from "../../services/apiService";
import { Link } from "react-router-dom";
import BackArrow from "src/atoms/backArrow/backArrow";

const CustomerSearch = () => {
  const loginContext = useContext(LoginContext);
  const [phoneNumberClass, setPhoneNumberClass] = useState("input-phone-btn");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isValidPhoneNumber, setValidPhoneNumber] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [customerData, setCustomerData] = useState({});
  const [loader, setLoader] = useState(false);
  const [errorMsgTxt, setErrorMsgTxt] = useState("")

  const history = useHistory();

  useEffect(() => {
    if (window.webkit && window.webkit.messageHandlers) {
      try {
        window.webkit.messageHandlers.reservePage.postMessage({
          reserve: false,
        });
      } catch (e) {
        // console.log(e);
      }
    }
  }, [loginContext.state.countryList]);

  const getUserDetails = async () => {
    console.log("Phone Number ", phoneNumber);
    setLoader(true);

    let config = {
      method: "post",
      url: `api/customer/getUserData`,
      headers: { "Content-Type": "application/json" },
      data: { phone_number: phoneNumber },
    };
    await makeAPICall(config)
      .then((response) => {
        setLoader(true);
        if (response?.data?.status === "SUCCESSFUL") {
          setLoader(false);
          setCustomerData(response?.data?.data);

          history.push({
            pathname: "/customer-details",
            state: {
              customerData: response?.data?.data,
            },
          });
        } else {
          setLoader(false);
          setShowErrorMsg(true);
        }
      })
      .catch((e) => {
        setLoader(false);
        setShowErrorMsg(true);
        if(e?.response?.status == "429"){
          setErrorMsgTxt("You have reached your allotted limit of phone lookup. Please try again later");
        }else if(e?.response?.status == "504"){
          setErrorMsgTxt("Gateway Timeout. Please try again");
        }else if(e?.response?.status == "403"){
          setErrorMsgTxt("No Ola accounts exists for the customer.");
        }else {
          setErrorMsgTxt("Something went wrong. Please try again");
        }
      });
  };

  const onPhoneFocus = () => {
    setPhoneNumberClass("input-phone-btn input-phone-btn-success");
  };

  const onBlurPhoneInput = () => {
    if (phoneNumber === "") {
      setPhoneNumberClass("input-phone-btn");
    }
  };

  const submitPhoneNumber = () => {
    getUserDetails();
  };

  const inputPhoneChange = (e) => {
    if (e?.target?.value && /^[0-9]/gi.test(e?.target?.value)) {
      let val = e.target.value.replace(/[^\d]/g, "");
      setPhoneNumber(val);
      if (val?.length === 10) {
        setValidPhoneNumber(true);
      } else if (val?.length < 10) {
        setValidPhoneNumber(false);
        setShowErrorMsg(false);
      }
    } else {
      setValidPhoneNumber(false);
      setPhoneNumber("");
    }
  };

  return (
    <div className="customer-search-main-container">
      <div className="right-container">
        <div className="cs-form-controls">
          <Link to="/phoneNumber">
            <BackArrow removeClass={true} />
          </Link>
          <div style={{ paddingLeft: "20px" }} className="label">
            Ola Champion Lead Status
          </div>
        </div>
        <div className="">
          <div className="customer-container">
            <div className="cs-form-container">
              {/* <div className="form-controls">
                <div className="label">Ola Champion Lead Status</div>
                <div className="reset" onClick={() => setShowCustomerDetail(!isShowCustomerDetail)}>Reset</div>
              </div> */}
              <div>
                <div
                  className={phoneNumberClass}
                  onFocus={onPhoneFocus}
                  onBlur={onBlurPhoneInput}
                >
                  <span className="country-select-span">
                    <img
                      src={
                        loginContext?.state?.selectedCountry
                          ? India //loginContext.state.selectedCountry.countryFlag
                          : India
                      }
                      alt=""
                    />
                    <Text
                      Class="code-btn"
                      textValue={
                        loginContext?.state?.selectedCountry
                          ? loginContext?.state?.selectedCountry?.dialingCode
                          : "+91"
                      }
                    />
                    {/* <img className="arrow-down-btn" src={Arrow} alt="" /> */}
                  </span>
                  <input
                    className="phone-number"
                    value={phoneNumber}
                    type="tel"
                    onChange={(e) => inputPhoneChange(e)}
                    placeholder={"Enter Phone Number"}
                    maxLength="10"
                  />
                </div>
                {/* {showErrorMsg && (
                  <div className="error-msg-container">
                    <span className="error-msg-text">
                      Invalid phone number, check again
                    </span>
                  </div>
                )} */}
                {!loader && (
                  <div className="search-img">
                    <img
                      src={showErrorMsg ? AlertInfoIcon : SearchIcon}
                      alt="search"
                    />
                    <p className="search-icon-txt">
                      {showErrorMsg
                        ? errorMsgTxt
                        : "Search customer by phone number"}
                    </p>
                  </div>
                )}
                {loader ? (
                  <button className="submit_btn submit_btn_disabled">
                    <div className="loader-container-np">
                      <LoaderLight
                        loaderData={loaderData}
                        loaderStyle="loader-light-np"
                      />
                    </div>{" "}
                  </button>
                ) : (
                  <div>
                    {!showErrorMsg && (
                      <button
                        className={
                          isValidPhoneNumber
                            ? "submit_btn"
                            : "submit_btn submit_btn_disabled"
                        }
                        type="submit"
                        onClick={() => submitPhoneNumber()}
                      >
                        Continue
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerSearch;
